export const formatSSEData = (eventData: string, contentArr: string[]) => {
  // 识别到\n的时候，就变成下一个点了
  const contentIndex = Math.max(contentArr.length - 1, 0);
  if (eventData.includes("\\n")) {
    const [current, next] = eventData.split("\\n");
    contentArr[contentIndex] += current;
    // 去掉元素的序号 或者 序号和点
    contentArr.push(next.replace(/^\d+\.?\s*/, ''));
  } else {
    if (!contentArr[contentIndex]) {
      contentArr[contentIndex] = "";
    }
    // 去掉元素为空时接收到的序号 或者 点 或者序号和点
    const formatEventData = contentArr[contentIndex] ? eventData : eventData.replace(/^\d*\.?\s*/, '');
    contentArr[contentIndex] += formatEventData;
  }
};

export const formatContentSSEData = (eventData: string, contentArr: string[]) => {
  // 识别到\n的时候，就变成下一个点了
  const contentIndex = Math.max(contentArr.length - 1, 0);
  if (eventData.includes("\\n")) {
    const [current, next] = eventData.split("\\n");
    contentArr[contentIndex] += current;
    // 去掉元素的序号 或者 序号和点
    contentArr.push(next);
  } else {
    if (!contentArr[contentIndex]) {
      contentArr[contentIndex] = "";
    }
    contentArr[contentIndex] += eventData;
  }
};

